import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import DashboardOverview from '../components/DashboardOverview';

export default function DashboardPage() {
  return (
    <DashboardLayout>
      <DashboardOverview />
    </DashboardLayout>
  );
}
